import * as ol from 'openlayers';
import { HtmlComponent } from './../../html-component';
import { MapToggleButton } from './map-toggle-button';
import { MapPulseButton } from './map-pulse-button';
import { MapDrawInteractionStyles } from './map-draw-interaction-styles';
import { MapDrawInteractionCircle } from './map-draw-interaction-circle';
import { SelectLocationCommandExecutor } from './../../../commands/select-location-command-executor';

import { Gui } from './../../../gui';
import { Map } from './../map';

// import html
import template from './map-draw-interaction-ui.hogan.html';

export class MapDrawInteractionUI extends HtmlComponent {
    public isDraggingCircle: boolean = false;
    private currentInteraction: any = false;

    private circles: MapDrawInteractionCircle[] = [];

    private drawButton: MapToggleButton;
    private clearButton: MapPulseButton;

    private interactionLayer: any;

    private lastCreatedCommand: any;
    private lastCreatedFeature: any;
    public popupInteractionTime: number = new Date().getTime() / 1000;

    constructor(private map: Map, private gui: Gui) {
        super(template, {});
        this.initInteractionLayer();

        this.initDrawInteraction();
        this.subscribeToNewLocationFilters();
    }

    // **************** Filter Connection *****************

    private subscribeToNewLocationFilters() {
        this.gui.commandManager.createdLocationCommand.attach((commandExecutor: SelectLocationCommandExecutor) => {
            if (this.lastCreatedCommand) {
                const circle = new MapDrawInteractionCircle(commandExecutor, this.gui, this);
                circle.feature = this.lastCreatedFeature;
                this.circles.push(circle);
            } else {
                const circle = new MapDrawInteractionCircle(commandExecutor, this.gui, this);
                this.circles.push(circle);
            }
            this.lastCreatedCommand = false;
        });
    }

    // **************** End Filter Connection *****************

    private initInteractionLayer() {
        const source = new ol.source.Vector({ wrapX: false });
        this.interactionLayer = new ol.layer.Vector({
            source,
            style: MapDrawInteractionStyles.returnStyleAfterDraw
        });
        this.map.olMap.addLayer(this.interactionLayer);
    }

    private initDrawInteraction() {
        this.drawButton = new MapToggleButton(
            this.enableInteraction,
            this.disableInteraction,
            'Draw',
            'fa-circle-thin'
        );
        this.drawButton.addToParent(this);
        this.clearButton = new MapPulseButton(this.clearShapes, 'Clear', 'fa-times');
        this.clearButton.addToParent(this);
    }

    private clearShapes = () => {
        // invokeDelete removes related UI elements in all listeners!!
        // so be careful with foreach!
        const copy = this.circles.map(el => {
            return el;
        });

        copy.forEach(circle => {
            circle.invokeDelete();
        });
    }

    public removeCircle = (circle: MapDrawInteractionCircle) => {
        this.circles.splice(this.circles.indexOf(circle), 1);
        this.interactionLayer.getSource().removeFeature(circle.feature);
    }

    private enableInteraction = () => {
        this.currentInteraction = new ol.interaction.Draw({
            source: this.interactionLayer.getSource(),
            type: 'Circle',
            style: MapDrawInteractionStyles.returnStyleDuringDraw
        });

        this.currentInteraction.on('drawstart', (el: any) => {
            this.map.popup.hide();
            this.isDraggingCircle = true;
            // hack, avoid click on release
            this.popupInteractionTime = new Date().getTime() / 1000;
        });

        this.currentInteraction.on('drawend', (el: any) => {
            // features are added by an event to have one point of access.
            const feature = el.feature;
            feature.setId(this.circles.length);
            MapDrawInteractionStyles.shapesDataIdsToActive[feature.getId()] = true;
            this.drawButton.disable();

            this.lastCreatedCommand = true;
            this.lastCreatedFeature = feature;
            const command: SelectLocationCommandExecutor = this.gui.commandManager.addLocationCommandExecutor();
            // dirty hack to indicate that the command was created here (since openlayers
            // already adds the feature.. )

            const center = feature.getGeometry().getCenter();
            const radius: number = feature.getGeometry().getRadius();
            const x: number = center[0];
            const y: number = center[1];

            command.requestExecute({
                circleOL: { x, y, radius },
                circle: null,
                enabled: true
            });
            this.isDraggingCircle = false;
            // hack, avoid click on release
            this.popupInteractionTime = new Date().getTime() / 1000;
        });

        this.map.olMap.addInteraction(this.currentInteraction);
        this.map.olMap.removeInteraction(this.map.clickInteraction);
    }

    private disableInteraction = () => {
        this.map.olMap.removeInteraction(this.currentInteraction);
        this.map.olMap.addInteraction(this.map.clickInteraction);
        this.currentInteraction = false;
    }
}
